module.exports = __webpack_public_path__ + "img/170103.d37ffa79.jpg";